import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { REGISTER } from "app/model/register.model";
import { RegisterService } from "app/services/register/register.service";
// import { CookieService } from "ngx-cookie";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie";

@Component({
  selector: "retrieveDialog",
  templateUrl: "./retrieve.component.html",
  styleUrls: ["./retrieve.component.scss"]
})
export class RetrieveComponent implements OnInit {

  displays:string = 'none';

  @Input() visible: boolean = false;

  @Output() destrop: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() formdata: FormGroup;

  codeID: string;
  /**
     * if choice is true, means user is going to submit data,
     * if choice is false, means user is going to save data,
     */

  resellerID: string = "null";

  constructor(
    private registerService: RegisterService,
    // private cookieService: CookieService,
    private router: Router,
    private cookieService: CookieService
  ) {}

  ngOnInit() {
    document.body.style.overflow = "hidden";
  }

  preventClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  retrieve(event) {
    // this.router.navigate(["/register/" + "0000000007"]).then(() => {
    //   this.closePop();
    // });
    this.cookieService.putObject('retrievecode', this.codeID);
    // debugger;
    this.router.navigate(['']).then(() => {
      // console.log('directly to another page');
      location.reload();
      this.closePop(event);
    });
  }

  closePop(event) {
    document.body.style.overflow = "auto";
    this.destrop.emit(false);
    console.log('do i emitted event here: ', false);
    this.visible = false;
    event.preventDefault();
    event.stopPropagation();
  }
}



// WEBPACK FOOTER //
// ./src/app/register/retrievedialog/retrieve.component.ts